import * as types from "./../types/types";
import { DEVURL } from "../../apis/envUrl";
import Api from "../../apis";

export const getDSBPScreenData =
  (BU, Region, allocation) => async (dispatch) => {
    try {
      // const res = await axios.get(`${DEVURL}/fetchDSBPID/${BU}/${Region}/${ProjectID}`);
      let headers = {
        "Content-Type": "application/json",
        "Content-Language": "en-US",
        "Access-Control-Allow-Origin": "*",
      };
      const api = new Api();
      const axiosInstance = await api.init({ headers });

      const res = await axiosInstance({
        url: `${DEVURL}/fetchDSBPScreenDetails?bu=${BU}&region=${Region}&showAllocated=${allocation}`,
        method: "GET"
      });

      if (res?.data === null) {
        dispatch({
          type: types.GET_ALL_DSBP_SCREEN_DATA,
          payload: "No records found",
        });
      } else {
        if (res.status === 200) {
          dispatch({
            type: types.GET_ALL_DSBP_SCREEN_DATA,
            payload: res.data.DSBPDetails.DSBP_InitiativeIDPage,
          });
        } else {
          dispatch({
            type: types.GET_ALL_DSBP_SCREEN_DATA_ERROR,
            payload: "Data not found",
          });
        }
      }
    } catch (err) {
      console.error(err);
      dispatch({ type: types.GET_ALL_DSBP_SCREEN_DATA_ERROR, payload: err });
    }
  };
